
























import Vue from 'vue'
import * as am4core from '@amcharts/amcharts4/core'
import * as am4charts from '@amcharts/amcharts4/charts'
import am4themes_animated from '@amcharts/amcharts4/themes/animated'
import { ChartTAPData } from '@/model/dashboard/ChartTAPData'
import moment from 'moment'
import _ from 'lodash'

am4core.useTheme(am4themes_animated)

interface ComponentData {
  chart: any
  toggleButtons: number
  minYear: number
  maxYear: number
  selectedYear: number
  chartData: any | null
}

export default Vue.extend({
  name: 'ProductSalesChart',

  props: {
    productSalesChartLabel: String,
    productSalesChartDate: String,
    productSalesChartData: {
      type: Array as () => Array<ChartTAPData>
    }
  },

  data (): ComponentData {
    return {
      chart: undefined,
      toggleButtons: 0,
      minYear: parseInt(moment().format('YYYY')),
      maxYear: parseInt(moment().format('YYYY')),
      selectedYear: parseInt(moment().format('YYYY')),
      chartData: null
    }
  },

  watch: {
    toggleButtons (newVal: number): void {
      this.createChart()
    }
  },

  methods: {
    onBeforeClick (): void {
      this.selectedYear = this.selectedYear - 1
      this.createChart()
    },

    onNextClick (): void {
      this.selectedYear = this.selectedYear + 1
      this.createChart()
    },

    createChart (): any {

      //@ts-ignore
      let chart = am4core.create(this.$refs.columnChart, am4charts.XYChart)

      const data = [
        { "month": 1, "label": "01" },
        { "month": 2, "label": "02" },
        { "month": 3, "label": "03" },
        { "month": 4, "label": "04" },
        { "month": 5, "label": "05" },
        { "month": 6, "label": "06" },
        { "month": 7, "label": "07" },
        { "month": 8, "label": "08" },
        { "month": 9, "label": "09" },
        { "month": 10, "label": "10" },
        { "month": 11, "label": "11" },
        { "month": 12, "label": "12" }
      ]

      if(this.chartData[this.selectedYear]) {
        chart.data = data.map((item: any) => {
          const filteredData: ChartTAPData[] = this.chartData[this.selectedYear].filter((i: ChartTAPData) => i.month === item.month.toString())
          /*const grouped = _.groupBy(filteredData, 'name')
          item.data = _.map(grouped, (items, name) => ({
            name,
            value: _.sumBy(items, (i) => parseInt(i.sum)),
          }))*/
          /*item.data = filteredData.map((i: ChartTAPData) => {
            return {name: i.name, value: i.sum}
          })*/
          filteredData.forEach((i: ChartTAPData) => {
            item[i.name] = parseInt(i.sum)
          })
          return item
        })

        if (this.toggleButtons === 1) {
          let q: any[] = []
          chart.data.forEach((item: any, index: number) => {
            if (index < 3) {
              if (q[0]) {
                for (let key in item) {
                  if (key !== 'month' && key !== 'label') {
                    q[0][key] = (q[0][key] || 0) + item[key];
                  }
                }
              } else {
                item.month = ''
                item.label = 'Q1'
                q.push(item)
              }
            } else if (index < 6) {
              if (q[1]) {
                for (let key in item) {
                  if (key !== 'month' && key !== 'label') {
                    q[1][key] = (q[1][key] || 0) + item[key];
                  }
                }
              } else {
                item.month = ''
                item.label = 'Q2'
                q.push(item)
              }
            } else if (index < 9) {
              if (q[2]) {
                for (let key in item) {
                  if (key !== 'month' && key !== 'label') {
                    q[2][key] = (q[2][key] || 0) + item[key];
                  }
                }
              } else {
                item.month = ''
                item.label = 'Q3'
                q.push(item)
              }
            } else {
              if (q[3]) {
                for (let key in item) {
                  if (key !== 'month' && key !== 'label') {
                    q[3][key] = (q[3][key] || 0) + item[key];
                  }
                }
              } else {
                item.month = ''
                item.label = 'Q4'
                q.push(item)
              }
            }
          })

          chart.data = q
        }
      } else {
        chart.data = data
      }

      // Add and configure Series
      let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis())
      categoryAxis.dataFields.category = "label"
      categoryAxis.renderer.grid.template.location = 0
      categoryAxis.renderer.minGridDistance = 20

      chart.yAxes.push(new am4charts.ValueAxis())

      // Create series
      function createSeries (field: string, name: string): any {

        // Set up series
        let series = chart.series.push(new am4charts.ColumnSeries())
        series.name = name
        series.dataFields.valueY = field
        series.dataFields.categoryX = 'label'
        series.sequencedInterpolation = true

        // Make it stacked
        series.stacked = true

        // Configure columns
        series.columns.template.width = am4core.percent(60)
        series.columns.template.tooltipText = '[bold]{name}[/]\n[font-size:14px] {valueY}'

        // Add label
        let labelBullet = series.bullets.push(new am4charts.LabelBullet())
        labelBullet.locationY = 0.5
        labelBullet.label.hideOversized = true
        return series
      }

      let uniqueKeys = new Set()

      chart.data.forEach((item: any) => {
        Object.keys(item).forEach(key => uniqueKeys.add(key))
      })

      uniqueKeys.forEach((item: any) => {
        if(item !== 'month' && item !== 'label') {
          createSeries(item, item.toString())
          //calculateTrendLine(chart.data, item, `${item}Trend`)
          //let trend = createTrendSeries(`${item}Trend`, `${item} Trend`)
          //trend.hidden = true
        }
      })

      /*function createTrendSeries(field: any, name: any) {
        let series: any = chart.series.push(new am4charts.LineSeries())
        series.dataFields.valueY = field
        series.dataFields.categoryX = "label"
        series.name = name
        series.tooltipText = "{valueY}"
        series.strokeWidth = 1

        series.tooltipText = "{valueY.formatNumber('#.00')}"
        series.strokeDasharray = "5,5"

        return series
      }

      //Trend line calculation(linear regression)
      function calculateTrendLine(data: any[], field: string, trendField: string) {
        const values = data
            .map((d, i) => ({ x: i, y: d[field] }))
            .filter(d => typeof d.y === 'number')

        const n = values.length
        if (n < 2) return

        const sumX = values.reduce((acc, d) => acc + d.x, 0)
        const sumY = values.reduce((acc, d) => acc + d.y, 0)
        const sumXY = values.reduce((acc, d) => acc + d.x * d.y, 0)
        const sumX2 = values.reduce((acc, d) => acc + d.x * d.x, 0)

        const slope = (n * sumXY - sumX * sumY) / (n * sumX2 - sumX * sumX)
        const intercept = (sumY - slope * sumX) / n

        values.forEach(d => {
          if (chart.data[d.x]) {
            chart.data[d.x][trendField] = slope * d.x + intercept
          }
        })
      }*/

      // Add a legend
      chart.legend = new am4charts.Legend();
      chart.legend.scrollable = true;
      //@ts-ignore
      let legendContainer = am4core.create(this.$refs.legend, am4core.Container);
      legendContainer.layout = "vertical";
      legendContainer.width = am4core.percent(100);
      legendContainer.height = am4core.percent(100);
      chart.legend.parent = legendContainer;
      //chart.legend = new am4charts.Legend()

      let cellSize = this.toggleButtons === 1 ? 3*35 : 35
      chart.events.on('datavalidated', function (ev: any) {

        // Get objects of interest
        let chart = ev.target
        let categoryAxis = chart.xAxes.getIndex(0)

        // Calculate how we need to adjust chart height
        let adjustWidth = chart.data.length * cellSize - categoryAxis.pixelWidth

        // get current chart height
        let targetWidth = chart.pixelWidth + adjustWidth

        // Set it on chart's container
        chart.svgContainer.htmlElement.style.width = targetWidth + 'px'

      })

      this.chart = chart
    }
  },

  mounted () {
    this.chartData = _.groupBy(this.productSalesChartData, 'year')

    const years = Object.keys(this.chartData).map(Number)
    this.minYear = Math.min(...years)

    this.createChart()
  },

  beforeDestroy () {
    if (this.chart) {
      this.chart.dispose()
    }
  }

})
